module.exports = __webpack_public_path__ + "static/media/omdurman.596d671f.png";